import PropTypes from 'prop-types';
import React from 'react';
import { memberTypeProptype } from '../../../../Includes/GroupPropsShape';
import { userProptype } from '../../../../Includes/userProps';
import Button from '../../../../Input/Button/Button';
import { Radio, RadioGroup } from '../../../../Input/RadioGroup/RadioGroup';
import UserOverviewTag from '../../../../Users/UserOverviewTag/UserOverviewTag';

import './MemberUser.scss';

export default class MemberUser extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            selectedValue: props.groupMemberType,
        };
    }

    static propTypes = {
        /**
         * user's data
         */
        user: userProptype.isRequired,
        /**
         * type/role of the member
         */
        groupMemberType: memberTypeProptype,
        /**
         * fetch for update member's memberType, ManageMember's state will be updated to reflects the change
         */
        handleUpdateMember: PropTypes.func.isRequired,
        /**
         * fetch for removing member, ManageMember's state will be updated to reflects the change
         */
        handleRemoveMember: PropTypes.func.isRequired,
    };

    static defaultProps = {
        user: {},
        groupMemberType: 'member',
        handleUpdateMember: () => {},
        handleRemoveMember: () => {},
    };

    componentDidUpdate() {
        const { groupMemberType } = this.props;
        this.setState({ selectedValue: groupMemberType });
    }

    handleChange = (value) => {
        const {
            handleUpdateMember,
            user: { userId },
        } = this.props;
        handleUpdateMember(userId, value, () =>
            this.setState({ selectedValue: value })
        );
    };

    render() {
        const { selectedValue } = this.state;
        const { user, groupMemberType, handleRemoveMember } = this.props;
        const isMemberOwner = groupMemberType === 'owner';
        return (
            <div className="component-Groups-ManageMembers-MemberList-MemberUser">
                <div className="user-info">
                    <UserOverviewTag
                        cssClass={'profile-position'}
                        user={user}
                        showToolTipOnHover={true}
                    />
                    {!isMemberOwner && (
                        <Button
                            type="tertiary-blue-gray"
                            value="Remove"
                            class="btn-input"
                            inputStyle="btn-input"
                            onClick={handleRemoveMember(user.userId)}
                        />
                    )}
                </div>
                {isMemberOwner ? (
                    <div className="owner-role">Group owner</div>
                ) : (
                    <RadioGroup
                        cssClass="role-options"
                        name={`role-${user.userId}`}
                        selectedValue={selectedValue}
                        onChange={this.handleChange}
                    >
                        <Radio value="admin" labelText="Admin" />
                        <Radio value="moderator" labelText="Moderator" />
                        <Radio value="member" labelText="Member" />
                    </RadioGroup>
                )}
            </div>
        );
    }
}
